/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineSystemService() {
        let systemService = {};
        systemService.getSites = function (){
            return axios.get("/api/SystemService/GetSites");
        };
        return systemService;
    }
    //define globally if it doesn't already exist
    if (typeof (systemService) === "undefined") {
        window.systemService = defineSystemService();
    } else {
        console.log("systemService already defined.");
    }
})(window);